/* eslint-disable @typescript-eslint/no-explicit-any */
import { getRequest, postRequest, putRequest } from '../../../../services/httpService';

export interface Type {
  id: number;
  name: string;
  name_label: string;
}

export interface Category {
  id: number;
  name: string;
  name_label: string;
  types: Type[];
}

export interface Module {
  id: number;
  name: string;
  name_label: string;
  categories: Category[];
}

export interface UserDetail {
  id: number;
  email: string;
  first_name: string;
  gender__name: string;
  last_name: string;
  username: string;
  role: string;
  appointment_type: string;
  is_active: boolean;
  user_type: string;
  is_locked: boolean;
  is_except:boolean
}

export interface Permission {
  type_id: number;
  action: string[];
  male: boolean;
  female: boolean;
}

export interface DetailedPermission {
  id: number;
  type: number;
  type_name: string;
  action: string;
  male: boolean;
  female: boolean;
  name: string;
  code: string;
  module: string;
  category: string;
  module_name: string;
  category_name: string;
}

export interface PermissionResponse {
  permissions: DetailedPermission[];
}
export interface GrantedRolePermission {
  name: string;
  permissions: Permission[];
}

export interface GrantedUserPermission {
  user_ids: number[];
  permissions: Permission[];
}

export interface RoleWithUsers {
  role_id: number;
  role_name: string;
  role_name_label: string;
  except_count:number
  users: UserDetail[];
}

export interface ModulesResponse {
  meta: {
    limit: number;
    next: null | string;
    offset: number;
    previous: null | string;
    total_count: number;
  };
  objects: Module[];
}
export interface PermissionDetail {
  access: string;
  male: boolean;
  female: boolean;
}

export interface TypePermission {
  name: string;
  id: number;
  permissions: PermissionDetail[];
}

export interface Submodule {
  name: string;
  type: TypePermission[];
}

export interface ModulePermission {
  name: string;
  submodules: Submodule[];
}

export interface GrantedPermisssionsObject {
  modules: ModulePermission[];
}



export function getUsersByRole(): Promise<RoleWithUsers[]> {
  const url = 'users/group-by-role/';  
  return getRequest(url);
}

export function getModules(): Promise<ModulesResponse> {
  const url = 'modules/';  
  return getRequest(url);
}
export function getPermissionsByUser(UserId: number): Promise<PermissionResponse> {
  const url = `users/${UserId}/permissions/`;
  return getRequest(url);
}

export function getPermissionsByRole(RoleId: number): Promise<PermissionResponse> {
  const url = `roles/${RoleId}/`; 
  return getRequest(url);
}


export function postUserPermissions(data: GrantedUserPermission): Promise<any> {
  const url = 'users/assign-permissions/';
  return postRequest(url, data);
}

export function postRolePermissions(id: number, data: GrantedRolePermission): Promise<any> {
  const url = `roles/${id}/`;
  return putRequest(url, data);
}
